import { request } from "../../apis";

export const apiGetProject = (params) => request("get", `/facility/index`, params, true);

export const apiGetProjectDetail = (params) => request("get", `/facility/goleaseid`, params, true);

export const apiPostBuy = ({ params }) => request("post", `/facility/buy`, params, true);
